import { optionsToStrategy } from "@/common/utils/optionsToStrategy";

export const eventableTypeOptions = [
  { label: 'Consumo', value: 'Client::Consumption' },
  { label: 'Estorno', value: 'Billing::Refund' },
  { label: 'Tarifa TEF', value: 'Billing::TefTransaction' },
];

export const eventableTypeTranslations = optionsToStrategy(eventableTypeOptions);
